/* eslint-disable */
import { lazy } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';
import { components } from 'react-select/dist/react-select.cjs.prod'
import { sub } from 'date-fns';
import { icon } from '@fortawesome/fontawesome-svg-core';


const PublisherArticle = lazy(() => import('Publisher/PublisherArticle/PublisherArticle'));
const PublisherClassifications = lazy(() => import('Publisher/PublisherClassifications/Classifications'));
const NewManuscript = lazy(() => import('Publisher/PublisherNewManuscript/NewManuscripts'));
const PublisherInvite = lazy(() => import('Publisher/PublisherArticle/PublisherInvite'));
const PublisherAddReview = lazy(() => import('Publisher/PublisherArticle/PublisherAddReview'));
const PublisherAddClassification = lazy(() => import('Publisher/PublisherArticle/PublisherAddClassification'));
const PublisherEditClassification = lazy(() => import('Publisher/PublisherClassifications/PublisherEditClassification'))

const CompletedArticles = {
    accepted: lazy(() => import('Publisher/CompletedArticles/SubArticles/AcceptedArticle/AcceptedArticles')),
    published: lazy(() => import('Publisher/CompletedArticles/SubArticles/Alreadypublisher/AlreadyPublished')),
    rejected: lazy(() => import('Publisher/CompletedArticles/SubArticles/RejectedArticle/RejectedArticles')),
    withdrawn: lazy(() => import("Publisher/CompletedArticles/SubArticles/Withdrawn/Withdrawn")),
};

const InviteReviewer1 = lazy(() => import('Publisher/CompletedArticles/SubArticles/AcceptedArticle/InviteReviewer1'));
const AddReviewer1 = lazy(() => import('Publisher/CompletedArticles/SubArticles/AcceptedArticle/AddReviewer1'));
const AddClassification1 = lazy(() => import('Publisher/CompletedArticles/SubArticles/AcceptedArticle/AddClassification1'));

const InviteReview2 = lazy(() => import('Publisher/CompletedArticles/SubArticles/Withdrawn/InviteReview2'));
const AddReview2 = lazy(() => import('Publisher/CompletedArticles/SubArticles/Withdrawn/AddReview2'));
const AddClassification2 = lazy(() => import('Publisher/CompletedArticles/SubArticles/Withdrawn/AddClassification2'));
const ArticleAssignEditor = lazy(() => import('Publisher/PublisherArticle/ArticleAssignEditor'));

const PublisherEditors = lazy(() => import('Publisher/PublisherEditor/PublisherEditor'));
const PublisherAuthors = lazy(() => import('Publisher/PublisherAuthors/PublisherAuthor'));
const PublisherReviewers = lazy(() => import('Publisher/PublisherReviewers/Reviewers'));

const Notifications = {
    author_notification: lazy(() => import('../src/Publisher/PublisherNotifications/AuthorNotifications/AuthorNotification')),
    editor_notification: lazy(() => import('../src/Publisher/PublisherNotifications/EditorNotifications/EditorNotifications')),
};

const Inbox = lazy(() => import('Publisher/Inbox/Inbox'));
const ContactQueries = lazy(() => import('Publisher/ContactQueries/ContactQueries'));
const Search = lazy(() => import('Publisher/PublisherSearch/Search'));
const RejectedManuscripts = {
    Preqc: lazy(() => import('Publisher/RejectedManuscript/Preqq'))
};

const SuggestReviewers = lazy(() => import('Publisher/PublisherReviewers/SuggestReviewers'))
const Login = lazy(() => import('views/default/Login'));
const Profile = lazy(() => import('Author/Profile/Profilepage'));
const PublisherDashboard = lazy(() => import('Publisher/PublisherDashboard/PublisherDashboard'));

const AddReview = lazy(() => import('Publisher/PublisherReviewers/AddReviewers1'));
const AddClassifi = lazy(() => import('Publisher/PublisherReviewers/AddClassification1'))
const PublisherReviewForm = lazy(() => import('Publisher/PublisherArticle/RevFormPublisher'));
const AddClassification4 = lazy(() => import('Publisher/PublisherClassifications/AddClassification4'));

const assignEditor = lazy(() => import('Publisher/PublisherEditor/AssignEditor'));

const editorList = lazy(() => import('Publisher/PublisherEditor/EditorList'))

const paperSubmission = lazy(() => import('Publisher/PublisherAuthors/PaperSubmission'));

const PublisherProfile = lazy(() => import('Publisher/PublisherProfile/PublisherProfile'))

const Transactionlist = lazy(() => import('Publisher/Transactionlist/Transactionlist'))
const TotalArticles =lazy(()=> import ('Publisher/TotalArticles/TotalArticles'))

const authordata = JSON.parse(localStorage.getItem('authorpayload'));
const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const PublisherroutesAndMenuItems = {
    mainMenuItems: [
        {
            path: DEFAULT_PATHS.APP,
            exact: true,
            redirect: true,
            // to: `${appRoot}/dashboard`,
            to: `${appRoot}/PublisherDashboard`,
        },
        {
            path: `${appRoot}/PublisherDashboard`,
            component: PublisherDashboard,
            label: 'Dashboard',
            icon: 'shop',
        },



        {
            path: `${appRoot}/articles`,
            exact: true,
            redirect: true,
            to: `${appRoot}/articles/newmanuscript`,
            label: 'Articles',
            icon: 'shop',
            subs: [
                { path: '/NewManuscript', label: 'New Manuscript', component: NewManuscript },
                { path: '/publisher_articles', label: 'Articles', component: PublisherArticle },
                { path: '/preqc_rejected', label: 'Preqc Rejected', component: RejectedManuscripts.Preqc },

            ]

        },

        // {
        //     path: `${appRoot}/publisher_articles`,
        //     component: PublisherArticle,
        //     label: 'Articles',
        //     icon: 'shop'
        // }
        // ,

        // {
        //     path: `${appRoot}/NewManuscript`,
        //     component: NewManuscript,
        //     label: 'New Manuscript',
        //     icon: 'shop'
        // },

        {
            path: `${appRoot}/completed_articles`,
            exact: true,
            redirect: true,
            to: `${appRoot}/completed_articles/accepted_articals`,
            label: 'CompletedArticles',
            icon: 'shop',
            subs: [
                { path: '/accepted_articals', label: 'Accepted', component: CompletedArticles.accepted },
                { path: '/rejected_articals', label: 'Rejected', component: CompletedArticles.rejected },
                { path: '/withdrawn', label: 'Withdraw', component: CompletedArticles.withdrawn },
                // { path: '/published_articals', label: 'Already Published in Our/Other', component: CompletedArticles.published },
            ]
        },
        {
            path: `${appRoot}/users`,
            exact: true,
            redirect: true,
            to: `${appRoot}/users/authors`,
            label: 'Users',
            icon: 'shop',
            subs: [
                { path: '/authors', label: 'Authors', component: PublisherAuthors },
                {
                    path: `${appRoot}/Reviewers`,
                    exact: true,
                    redirect: true,
                    to: `${appRoot}/Reviewers/reviewers`,
                    label: 'Reviewers',
                    subs: [
                        { path: '/reviewers', label: 'Reviewers', component: PublisherReviewers },
                        { path: '/suggest_Reviewers', label: "Suggested Reviewers", component: SuggestReviewers }
                    ]

                },
                { path: '/Editors', label: 'Editors', component: PublisherEditors },

            ]

        },
        // {
        //     path: `${appRoot}/PublisherEditors`,
        //     component: PublisherEditors,
        //     label: 'Editors',
        //     icon: 'shop'

        // },
        // {
        //     path: `${appRoot}/PublisherAuthors`,
        //     component: PublisherAuthors,
        //     label: "Authors",
        //     icon: 'shop'
        // },
        // {
        //     path: `${appRoot}/PublisherReviewers`,
        //     component: PublisherReviewers,
        //     label: "Reviewers",
        //     icon: 'shop'
        // },
        {
            path: `${appRoot}/notifications`,
            exact: true,
            redirect: true,
            to: `${appRoot}/notifications/author_notifications`,
            label: "Notifications",
            icon: 'shop',
            subs: [
                { path: '/author_notifications', label: 'Author Notifications', component: Notifications.author_notification },
                { path: '/editor_notifications', label: 'Editor Notifications', component: Notifications.editor_notification },
                { path: '/inbox', label: 'Inbox', component: Inbox },
                { path: '/contact_queries', label: 'Contact Queries', component: ContactQueries }
            ]

        },
        // {
        //     path: `${appRoot}/inbox`,
        //     component: Inbox,
        //     label: 'Inbox',
        //     icon: 'shop'
        // },
        // {
        //     path: `${appRoot}/search`,
        //     component: Search,
        //     label: "Search",
        //     icon: 'shop'
        // },
        // {
        //     path: `${appRoot}/contact_queries`,
        //     component: ContactQueries,
        //     label: 'Contact Queries',
        //     icon: 'shop'
        // },
        // {
        //     path: `${appRoot}/rejected_manuscripts`,
        //     exact: true,
        //     redirect: true,
        //     to: `${appRoot}/rejected_manuscripts/preqq`,
        //     label: 'Rejected Manuscripts',
        //     icon: 'shop',
        //     subs: [
        //         { path: '/preqq', label: 'Preqq', component: RejectedManuscripts.Preqq }
        //     ]

        // },
        {
            path: `${appRoot}/publisherclassification`,
            component: PublisherClassifications,
            label: 'Classifications',
            icon: 'shop'
        },
        // {
        //     path:`${appRoot}/transactionlist`,
        //     component:Transactionlist,
        //     label:'Transaction List',
        //     icon:'shop'
        // },
        {
            path: `${appRoot}/login`,
            component: Login,
            // label:"Login",
            // icon:"shop"
        },
        // {
        //     path: `${appRoot}/Profile`,
        //     component: Profile,
        //     // label: 'Profile',
        //     // icon: 'shop'
        // },
        {
            path: `${appRoot}/article_assign_editor`,
            component: ArticleAssignEditor,
        },
        {
            path: `${appRoot}/review_form`,
            component: PublisherReviewForm,
        },
        {
            path: `${appRoot}/inviteReviewer`,
            component: PublisherInvite,
        },
        {
            path: `${appRoot}/AddReviewer`,
            component: PublisherAddReview,
        },
        {
            path: `${appRoot}/addClassification`,
            component: PublisherAddClassification,
        },
        {
            path: `${appRoot}/edit-classification`,
            component: PublisherEditClassification,
        },
        {
            path: `${appRoot}/inviteReviewer1`,
            component: InviteReviewer1,
        },
        {
            path: `${appRoot}/AddReviewer1`,
            component: AddReviewer1,
        },
        {
            path: `${appRoot}/AddClassification1`,
            component: AddClassification1,
        },
        {
            path: `${appRoot}/inviteReviewers2`,
            component: InviteReview2,
        },
        {
            path: `${appRoot}/AddReviewers2`,
            component: AddReview2,
        },
        {
            path: `${appRoot}/addclassification2`,
            component: AddClassification2,
        },
        {
            path: `${appRoot}/AddReviewer3`,
            component: AddReview
        },
        {
            path: `${appRoot}/AddClassification3`,
            component: AddClassifi
        },
        {
            path: `${appRoot}/assignNewEditor`,
            component: assignEditor
        },
        {
            path: `${appRoot}/editorList`,
            component: editorList
        },
        {
            path: `${appRoot}/paperSubmission`,
            component: paperSubmission
        },
        {
            path: `${appRoot}/AddClassification4`,
            component: AddClassification4
        },
        {
            path: `${appRoot}/assignNewEditor`,
            component: assignEditor
        },
        {
            path: `${appRoot}/PublisherProfile`,
            component: PublisherProfile
        },
        {
            path:`${appRoot}/Totalarticles`,
            component:TotalArticles
        }

        // --------------------------



    ],
    sidebarItems: [],
};





export default PublisherroutesAndMenuItems;
